import {useState, Suspense} from "react";
import {Outlet, useLocation} from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Preloader from "../Preloader/Preloader";
import {educationLevels} from "../EducationLevelSelection/EducationLevelSelection";
import {parseSelectedLevelsId} from "../DocumentLinksPage/DocumentLinksPage";

const Layout = () => {
    const [isBurgerOpen, setIsBurgerOpen] = useState(false);
    const location = useLocation();

    const handleBurgerClick = () => {
        setIsBurgerOpen(true);
    };

    const closeBurger = () => {
        setIsBurgerOpen(false);
    };

    const getSelectedLevelsId = () => {
        if (location.pathname.startsWith('/documents/')) {
            const level = location.pathname.split('/')[2];
            const selectedLevel = educationLevels.find(l => l.key === level);
            if (selectedLevel) {
                return parseSelectedLevelsId(selectedLevel._id);
            }
        }
        return null;
    };

    const selectedLevelsId = getSelectedLevelsId();

    return (
        <>
            <Header
                onClose={closeBurger}
                onOpen={handleBurgerClick}
                isOpenBurgerMenu={isBurgerOpen}
            />
            <div className="page-content">
                <Suspense fallback={<Preloader/>}>
                    <Outlet context={{selectedLevelsId}} />
                </Suspense>
            </div>
            <Footer selectedLevelsId={selectedLevelsId} />
        </>
    )
}

export {Layout};